/**
 * Permission strings used to hide controls the current staff member cannot use.
 * Hiding is required — letting a role click through and collect a 403 is the
 * behaviour the backend team asked us to avoid.
 *
 * Interview permissions (`interview.schedule` / `interview.update`):
 *   Admin · HR Manager · Hiring Manager · HR Executive · Technical Recruiter
 * Offer permissions (`offer.extend` / `offer.revoke`):
 *   Admin · HR Manager · Hiring Manager only
 *
 * The two sets differ — HR Executive and Technical Recruiter can run interviews
 * but cannot extend an offer, so the offer control must be gated on
 * `offer.extend` and never on an interview permission.
 * Mentor and Internship Coordinator hold none of these.
 */
export const PERMISSIONS = {
  APPLICATION_READ: "application.read",
  APPLICATION_REVIEW: "application.review",

  INTERVIEW_SCHEDULE: "interview.schedule",
  INTERVIEW_UPDATE: "interview.update",

  OFFER_EXTEND: "offer.extend",
  OFFER_REVOKE: "offer.revoke",
} as const;

/**
 * Application statuses an offer may be extended from.
 *
 * The backend applies NO status gate of its own — `OfferService.extend()` only
 * checks that the application exists and then sets `offer_extended` directly,
 * bypassing the FSM. That makes this list the only thing stopping an offer
 * going out to a rejected or withdrawn candidate, so keep it in sync if the
 * backend later adds its own guard.
 *
 * `offer_extended` is excluded deliberately: an application can hold only one
 * offer, and a second extend is silently ignored server-side.
 */
export const OFFER_EXTENDABLE_STATUSES = [
  "shortlisted",
  "interview_scheduled",
  "interviewed",
];
